// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Decco from "../../../../../../node_modules/decco/src/Decco.bs.js";
import * as Js_dict from "../../../../../../node_modules/rescript/lib/es6/js_dict.js";

function channel_encode(v) {
  return Js_dict.fromArray([
              [
                "consent_config_id",
                Decco.intToJson(v.consent_config_id)
              ],
              [
                "enabled",
                Decco.boolToJson(v.enabled)
              ]
            ]);
}

function consent_encode(v) {
  return Js_dict.fromArray([
              [
                "message_type",
                Decco.stringToJson(v.message_type)
              ],
              [
                "channels",
                Decco.arrayToJson(channel_encode, v.channels)
              ]
            ]);
}

function t_encode(v) {
  return Js_dict.fromArray([
              [
                "uuid",
                Decco.stringToJson(v.uuid)
              ],
              [
                "consents",
                Decco.arrayToJson(consent_encode, v.consents)
              ]
            ]);
}

export {
  channel_encode ,
  consent_encode ,
  t_encode ,
  
}
/* No side effect */
